import { formatCookieString } from '../cookies'
import { type AccountData } from '../models'

export const CUSTOM_COOKIE_ORDER: string[] = [
  'sessionid', 'ds_user_id', 'rur', 'mid', 'csrftoken', 'ig_did',
]

export function formatCustom(account: AccountData): string {
  const selected: Record<string, string> = {}
  for (const [k, v] of Object.entries(account.cookies)) {
    if (CUSTOM_COOKIE_ORDER.includes(k)) selected[k] = v
  }
  const cookieStr = formatCookieString(selected, CUSTOM_COOKIE_ORDER, true)
  const ua = account.userAgent || ''
  let email = ''
  if (account.emailLogin) {
    email = account.emailPassword
      ? `${account.emailLogin}:${account.emailPassword}`
      : account.emailLogin
  }
  return `${account.login}:${account.password}:${account.twofaKey}|${ua}|${cookieStr}||${email}`
}
